import React from "react";

const comments = () => {
  return (
    <svg
      width="18px"
      height="16px"
      viewBox="0 0 18 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Group 5</title>
      <g
        id="Kanban-Dashboard-UI"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Projects"
          transform="translate(-320.000000, -255.000000)"
          stroke="#7D90AA"
        >
          <g id="List1" transform="translate(224.000000, 133.000000)">
            <g id="e1" transform="translate(16.000000, 51.000000)">
              <g id="Group-5" transform="translate(81.000000, 72.000000)">
                <polyline
                  id="Stroke-3"
                  points="5.66666667 3.66666667 0.333333333 3.66666667 0.333333333 11 1.66666667 11 1.66666667 13.6666667 4.33333333 11 10.3333333 11 10.3333333 7.66666667"
                ></polyline>
                <polygon
                  id="Stroke-1"
                  points="11.6666667 7.66666667 14.3333333 10.3333333 14.3333333 7.66666667 15.6666667 7.66666667 15.6666667 0.333333333 5.66666667 0.333333333 5.66666667 3.66666667 5.66666667 7.66666667 10.3333333 7.66666667"
                ></polygon>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default comments;
